const Endpoints = {
  //---AUTH---
  authenticate: "backoffice/auth/authenticate",
  refreshToken: "backoffice/auth/refreshToken",
  logout: "backoffice/logout",

  //---USER NOTIFICATION---
  getUserNotification: "backoffice/userNotification/get",
  getAllUserNotifications: "backoffice/userNotification/getAll",
  getAllUserNotificationsByUserId: "backoffice/userNotification/getAllByUserId",
  getAllUserNotificationsByNotificationId:
    "backoffice/userNotification/getAllByNotificationId",

  //---APP NOTIFICATION---
  sendToTopic: "backoffice/appNotification/sendToTopic",
  sendToShopUsers: "backoffice/appNotification/sendToShopUsers",
  sendToClients: "backoffice/appNotification/sendToClients",
  sendToAll: "backoffice/appNotification/sendToAll",
  getAppNotificationsTopics: "backoffice/appNotification/getTopics",
  getAllAppNotifications: "backoffice/appNotification/getAll",

  //---SHOP---
  getShop: "backoffice/shop/get",
  searchShop: "backoffice/shop/search",
  createShop: "backoffice/shop/create",
  editShop: "backoffice/shop/updateShopDetails",
  updateShopOfficerDetails: "backoffice/shop/updateShopOfficerDetails",
  updateShopCardDetails: "backoffice/shop/updateShopCardDetails",
  updateShopBillingInfo: "backoffice/shop/updateShopBillingInfo",
  passivatePersonnel: "backoffice/shop/passivatePersonnel",
  activatePersonnel: "backoffice/shop/activatePersonnel",
  addSubscription: "backoffice/shop/addSubscription",
  addPersonnel: "backoffice/shop/addPersonnel",
  getInvalidSubscriptions: "backoffice/shop/getInvalidSubscriptions",
  setShopDisplayInDiscoveryList: "backoffice/shop/setDisplayInDiscoveryList",
  clearShopLocation: "backoffice/shop/clearLocation",
  suspendShop: "backoffice/shop/suspend",
  activateShop: "backoffice/shop/activate",

  //---CLIENT---
  getClient: "backoffice/client/get",
  searchClient: "backoffice/client/search",
  createClient: "backoffice/client/create",
  updateClientDetails: "backoffice/client/updateClientDetails",
  updateClientCard: "backoffice/client/updateClientCard",

  //---SUBSCRIPTION---
  updateSubscription: "backoffice/subscription/update",

  //---APPLICATION---
  updateApplication: "backoffice/application/update",
  addApplication: "backoffice/application/add",
  getApplication: "backoffice/application/get",
  getAllApplications: "backoffice/application/getAll",
  deleteApplication: "backoffice/application/delete/",

  //---APPLICATION STATUS---
  updateApplicationStatus: "backoffice/applicationStatus/update",
  addApplicationStatus: "backoffice/applicationStatus/add",
  getApplicationStatus: "backoffice/applicationStatus/get",
  getAllApplicationStatuses: "backoffice/applicationStatus/getAll",
  deleteApplicationStatus: "backoffice/applicationStatus/delete",
  getAllUnderMaintenance: "backoffice/applicationStatus/getAllUnderMaintenance",

  getAllSectors: "common/sector/getAll",
  getAllApps: "common/enum/getApps",

  //---OTHER CARDS---
  updateOtherCard: "backoffice/otherCardCompany/update",
  addOtherCard: "backoffice/otherCardCompany/add",
  getOtherCard: "backoffice/otherCardCompany/get",
  getAllOtherCards: "backoffice/otherCardCompany/getAll",
  deleteOtherCard: "backoffice/otherCardCompany/delete",

  //---OTHER CARD USAGE---
  getOtherCardStats: "backoffice/otherCard/stats",
  getOtherCardCompanyUsage: "backoffice/otherCard/companyUsage",
  getOtherCardClientsByCompany: "backoffice/otherCard/clientsByCompany",
  getOtherCardCustomCards: "backoffice/otherCard/customCards",

  //---OTHER STATISTICS---
  getStatistics: "backoffice/statistics/get",

  //---TRANSACTION HISTORY---
  getAllTransactions: "backoffice/transactionHistory/getAll",

  //---CARD BACKGROUND PRESET---
  getAllCardBackgroundPresets: "backoffice/cardBackgroundPreset/getAll",
  getCardBackgroundPreset: "backoffice/cardBackgroundPreset/get",
  createCardBackgroundPreset: "backoffice/cardBackgroundPreset/create",
  updateCardBackgroundPreset: "backoffice/cardBackgroundPreset/update", // /{id}
  replaceCardBackgroundPresetImage: "backoffice/cardBackgroundPreset/replaceImage", // /{id}
  deleteCardBackgroundPreset: "backoffice/cardBackgroundPreset/delete", // /{id}
};

export default Endpoints;
